import AdminContainer from "./AdminContainer";
import RevokeAdminContainer from './RevokeAdminContainer';
import AddAdminContainer from "./AddAdminContainer";
import EditAdminContainer from "./EditAdminContainer";
import PermissionListContainer from "./PermissionListContainer";

export {
    AdminContainer,
    RevokeAdminContainer,
    AddAdminContainer,
    EditAdminContainer,
    PermissionListContainer,
}